import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { push } from 'connected-react-router';

import { Row, Col, Button } from 'react-bootstrap';

import { isNullOrEmpty, trimAssetLink } from '../../../../utils/utilities';

import config from '../../../../../config';

import { CHANGE_SUBMISSION, SUBMISSION_STATUS } from '../../../../constants/submission';

import { CANCEL_IMPERSONATION } from '../../../../person/actions';

import { submissionCreate } from '../../../../submissions/actions';

const assetsURL = trimAssetLink(config.assetsURL);

export function ProductChoiceItem(props) {
    const { broker, description, features, name, subtitle, type, applicationForm } = props;

    return (
        <div data-type={type}>
            <div className="productContainer">
                <div className="textContainer">
                    <header>
                        <h4>{name}</h4>
                        <span>{subtitle}&nbsp;</span>
                    </header>
                    <div>
                        {features.length && (
                            <ul>
                                {features.map((feature, i) => {
                                    return <li key={i}>{feature}</li>;
                                })}
                            </ul>
                        )}
                        <a
                            download={applicationForm.download}
                            alt={applicationForm.alt}
                            target='blank'
                            href={`${assetsURL}/pdfs/${applicationForm.fileName}.pdf`}
                        >
                            Download Application
                        </a>
                        <Button
                            onClick={() => {
                                props.dispatch({
                                    type: CHANGE_SUBMISSION,
                                    payload: {
                                        submission: { type, status: SUBMISSION_STATUS.CLEARANCE }
                                    }
                                });
                                props.dispatch({ type: CANCEL_IMPERSONATION });

                                props.dispatch(submissionCreate({ Type: type }));

                                props.dispatch(push('/clearance'));
                            }}
                        id="btn-start-submission">
                            Start Submission
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
ProductChoiceItem.propTypes = {
    broker: PropTypes.string,
    description: PropTypes.string,
    dispatch: PropTypes.func,
    features: PropTypes.array,
    name: PropTypes.string,
    subtitle: PropTypes.string,
    type: PropTypes.string
};

ProductChoiceItem.defaultProps = {
    features: []
};

export default connect()(ProductChoiceItem);
